import { OnDestroy, NgZone } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SpinnerComponent } from './spinner.component';
import { Router, ActivationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/overlay";
import * as i2 from "@angular/router";
export class SpinnerService {
    constructor(overlay, router, ngZone) {
        this.overlay = overlay;
        this.router = router;
        this.ngZone = ngZone;
        this.destroy$ = new Subject();
        this.loaderSubject = new BehaviorSubject(false);
        this.loader$ = this.loaderSubject.asObservable();
    }
    initRouterEventSpinner() {
        this.router.events
            .pipe(takeUntil(this.destroy$))
            .subscribe((event) => this.checkRouterEvent(event));
    }
    checkRouterEvent(routerEvent) {
        if (routerEvent instanceof ActivationStart) {
            this.loading();
            return;
        }
        if (routerEvent instanceof NavigationEnd ||
            routerEvent instanceof NavigationCancel ||
            routerEvent instanceof NavigationError) {
            this.complete();
        }
    }
    loading() {
        if (this.overlayRef) {
            return;
        }
        this.ngZone.runOutsideAngular(() => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.overlayRef = this.overlay.create({
                    positionStrategy: this.overlay.position().global(),
                    scrollStrategy: this.overlay.scrollStrategies.block(),
                    hasBackdrop: true
                });
                const ref = this.overlayRef.attach(new ComponentPortal(SpinnerComponent));
                ref.instance.centerPos = true;
                ref.changeDetectorRef.detectChanges();
                this.loaderSubject.next(true);
            }, 200);
        });
    }
    complete() {
        clearTimeout(this.timer);
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = undefined;
        }
        this.loaderSubject.next(false);
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
SpinnerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SpinnerService_Factory() { return new SpinnerService(i0.ɵɵinject(i1.Overlay), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i0.NgZone)); }, token: SpinnerService, providedIn: "root" });
